module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showMenu) ? _c('div', {
    staticClass: "menu-container"
  }, [_c('span', {
    class: {
      active: _vm.tab === 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("Obecności")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.tab === 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("Kadra")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.tab === 2
    },
    on: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_vm._v("Struktura")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "mode": "out-in"
    }
  }, [(_vm.tab === 0) ? _c('EmployeeViewSwap', {
    on: {
      "toggleMenuVisibility": _vm.toggleMenuVisibility
    }
  }) : (_vm.tab === 1) ? _c('ActiveEmployees') : (_vm.tab === 2) ? _c('Structure') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b96f8ac!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/Employees.vue
// module id = 1101
// module chunks = 0